import { InjectionToken } from '@angular/core';
import { ZopUxLayoutLibConfig } from '../services/config/config.types';

export const ZOP_UX_LAYOUT_LIB_CONFIG =
    new InjectionToken<ZopUxLayoutLibConfig>('ZOP_UX_LAYOUT_LIB_CONFIG');
